"use client";

function normalizeTrend(trend) {
  if (trend === "up") return "increased";
  if (trend === "down") return "decreased";
  return trend ?? "unchanged";
}

function getValueTrendClass(normalizedTrend) {
  if (normalizedTrend === "increased") return "kbv-odds-value--up";
  if (normalizedTrend === "decreased") return "kbv-odds-value--down";
  return "";
}


export default function KeoOddsMatchOuCell({ line, side, odds, trend = "unchanged" }) {
  const normalizedTrend = normalizeTrend(trend);
  const trendClass = getValueTrendClass(normalizedTrend);
  const hasArrow = normalizedTrend === "increased" || normalizedTrend === "decreased";
  const normalCellClass = !hasArrow ? "kbv-odds-cell--normal" : "";

  const leftText = side === "O" ? (line || "-") : "-";
  const rightText = odds != null && odds !== "" && odds !== "-" ? odds : "-";

  return (
    <div className={`kbv-odds-cell grid grid-cols-[minmax(0,34px)_16px_minmax(0,48px)] items-center p-0 h-5 leading-5 text-xs cursor-pointer relative rounded-sm min-w-0 overflow-hidden w-full ${normalCellClass} ${trendClass}`}>
      <span className="min-w-0 px-0.5 text-xs font-normal text-[color:var(--kbv-odds-label-color)] overflow-hidden text-ellipsis whitespace-nowrap text-left">{leftText}</span>
      <span className="px-0.5 text-center text-xs font-bold text-[color:var(--kbv-odds-value-color)]">{side}</span>
      <span className={`min-w-0 pl-[2px] pr-[14px] text-xs font-bold text-[color:var(--kbv-odds-value-color)] relative text-right overflow-hidden text-ellipsis whitespace-nowrap ${trendClass}`}>
        <strong className="block overflow-hidden text-ellipsis whitespace-nowrap">{rightText}</strong>
      </span>
    </div>
  );
}
